import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { isOrNotConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import useEventLocation from 'hooks/useEventLocation';

const EventLocationFilter = ({ index }) => {
  const { eventLocations, isEventsLoading } = useEventLocation();
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              value={field.value}
              name={field.name}
              options={isOrNotConditionOptions}
              onChange={(e) => field.onChange(e.value)}
              filter
              className="w-100"
              placeholder="Select"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <Dropdown
              value={field.value?.location || ''}
              name={field.name}
              options={eventLocations}
              onChange={(e) => field.onChange({ location: e.value })}
              filter
              optionLabel={(v) => v?.title || v?.office_name || ''}
              optionValue={(v) => v?.office_location_id || v?.contact_id}
              className="w-100"
              placeholder="Select"
              dropdownIcon={isEventsLoading ? 'pi pi-spin pi-spinner' : undefined}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default EventLocationFilter;
